export default __webpack_public_path__ + "static/media/pp-w-12.81dc00b7.svg";